import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  inject,
  Inject,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BolsaService, BolseiroService } from '../../../api/services';
import { ButtonModule } from 'primeng/button';
import { TagModule } from 'primeng/tag';
import { TableModule } from 'primeng/table';
import { ProfissionalCompetenciaDetailsDTO } from '@app/features-modules/bolsa-de-profissionais/api';
import { ApiService } from '@core/providers/http';
import { AvatarModule } from 'primeng/avatar';
import { getInitials } from '@shared/pipes/initials.pipe';

@Component({
  selector: 'app-mais-detalhe-estudante',
  standalone: true,
  imports: [CommonModule, ButtonModule, TagModule, TableModule, AvatarModule],
  providers: [ApiService, BolseiroService],
  templateUrl: './mais-detalhe-estudante.component.html',
  styleUrls: ['./mais-detalhe-estudante.component.scss'],
})
export class MaisDetalheEstudanteComponent implements OnInit {
  imageError = false;

  getInitials(name?: string | null): string {
    return getInitials(name);
  }
  @Input() estudanteSelected: any;
  @Output() onCloseModal = new EventEmitter<boolean>();

  imagePreview: string | ArrayBuffer | null = null; // To store image as Base64 URL

  route: ActivatedRoute = Inject(ActivatedRoute);
  bolseiroService = inject(BolseiroService);

  bolseiroID!: string;
  listaCompetencias: ProfissionalCompetenciaDetailsDTO[] = [];

  showDetalhe: boolean = false;
  isLoading: boolean = false;
  perfilEstudante: any;
  bolseiroDetalhe: any = null;

  // NOVO: campos de matrícula atual
  matriculaAtual: any | null = null;
  currentAnoCurricular: string | null = null;
  currentCurso: string | null = null;
  currentFase: string | null = null;
  currentUnidInst: string | null = null;

  ngOnInit(): void {
    const id = Number(this.estudanteSelected?.id);
    if (id) this.getPhotoEstudante(id);
    this.resolveMatriculaAtualFromInput();
  }

  private normalize(s: any) {
    return String(s ?? '')
      .trim()
      .toLowerCase();
  }

  private resolveMatriculaAtualFromInput() {
    const arr = Array.isArray(this.estudanteSelected?.matricula)
      ? this.estudanteSelected.matricula
      : [];
    if (!arr.length) return;

    const emCurso = arr.find(
      (m: any) => this.normalize(m?.estadoDescricao) === 'em curso'
    );
    const byRecent =
      emCurso ??
      arr
        .slice()
        .sort(
          (a: any, b: any) =>
            (b?.dataInicio ? new Date(b.dataInicio).getTime() : 0) -
            (a?.dataInicio ? new Date(a.dataInicio).getTime() : 0)
        )[0];

    this.matriculaAtual = byRecent ?? null;

    if (this.matriculaAtual) {
      this.currentAnoCurricular = String(
        this.matriculaAtual.anoCurricular ?? ''
      );
      this.currentCurso = this.matriculaAtual.curso ?? null;
      this.currentFase = this.matriculaAtual.fase ?? null;
      this.currentUnidInst = [
        this.matriculaAtual.instituicaoEnsino,
        this.matriculaAtual.unidadeOrganica,
      ]
        .filter(Boolean)
        .join(' — ');
    }
  }

  getPhotoEstudante(id: number) {
    this.bolseiroService.getBolseiroFotoById(id).subscribe({
      next: (response) => {
        if (!response || !response.type.startsWith('image/')) {
        console.warn('Resposta não é imagem. A usar placeholder.');
        this.imagePreview = null;
        return;
      }
        const reader = new FileReader();
        reader.onload = () => {
          this.imagePreview = reader.result;
        };
        reader.readAsDataURL(response);
      },
      error: (err) => {
        console.error('Erro ao carregar imagem da instituição:', err);
        this.imagePreview = null;
      },
    });
  }

  closeModal() {
    this.onCloseModal.emit(true);
  }
}
